<template>
  <fragment>
    <v-form @submit.prevent="filterFinancialReport" class="search-forms">
      <v-row>
        <v-col cols="12" md="3" sm="4" v-if="isAdmin">
          <BaseSelect
            tabindex="3"
            label="Regional"
            :items="regionais"
            loader-height="5"
            v-model="filter.regional"
            item-text="nome"
            item-value="idregional"
            placeholder="Selecione a Regional"
            data-cy="regional"
            clearable
            @click:clear="filter.regional = null"
          />
        </v-col>
        <v-col cols="12" md="3" sm="4">
          <BaseSelect
            tabindex="5"
            label="Canal de Venda"
            :items="channelSales"
            data-cy="canal-venda"
            v-model="filter.channel"
            item-text="value"
            item-value="key"
            placeholder="Selecione o Canal de Venda"
            clearable
            @click:clear="filter.channel = null"
          />
        </v-col>
        <v-col cols="12" md="3" sm="4">
          <BaseSelect
            label="Forma de Pagamento"
            tabindex="6"
            :items="paymentMethods"
            v-model="filter.payment"
            item-text="key"
            item-value="value"
            placeholder="Selecione a Forma de Pagamento"
            clearable
            @click:clear="filter.payment = null"
          />
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu"
            v-model="menu"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Inicial do Pedido"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.initDateViewOrders"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.initDateOrders"
              :active-picker.sync="activePickerOrders"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu2"
            v-model="menu2"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Final do Pedido"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.endDateViewOrders"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.endDateOrders"
              :active-picker.sync="activePickerOrders2"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save2"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu3"
            v-model="menu3"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Inicial da Liberação"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.initDateViewRelease"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.initDateRelease"
              :active-picker.sync="activePickerRelease"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save3"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu4"
            v-model="menu4"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Final da Liberação"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.endDateViewRelease"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.endDateRelease"
              :active-picker.sync="activePickerRelease2"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save4"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex justify-end">
          <BaseButton
            tabindex="13"
            variant="filter"
            class="button rounded-xxl"
            type="submit"
            :loading="financialReportLoading"
          >
            Filtrar
          </BaseButton>
        </v-col>
      </v-row>
    </v-form>

    <v-data-table
      class="rounded-lg"
      hide-details
      no-data-text="Não há registros."
      loading-text="Buscando informações...."
      :loading="financialReportLoading"
      :headers="headerTableValues"
      :items="allFinancialReport.info"
      :items-per-page="10"
      :custom-sort="$relatorios_sinteticos.customSort"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Produtos por página:',
      }"
    >
      <template v-slot:item.transactioncode="{ item }">
        {{ item.transactioncode || "-" }}
      </template>
      <template v-slot:item.idtransacao="{ item }">
        {{ item.idtransacao || "-" }}
      </template>
      <template v-slot:item.valor_pedido="{ item }">
        {{ item.valor_pedido | moeda }}
      </template>
      <template v-slot:item.dt_pedido="{ item }">
        {{ item.dt_pedido | dthr_pt_br }}
      </template>
      <template v-slot:item.dt_liberacao="{ item }">
        {{ item.dt_liberacao | dthr_pt_br }}
      </template>
      <template v-slot:item.valor_juros="{ item }">
        {{ item.valor_juros | moeda }}
      </template>
      <template v-slot:item.valor_cancelado="{ item }">
        {{ item.valor_cancelado | moeda }}
      </template>
      <template v-slot:item.valor_desconto="{ item }">
        {{ item.valor_desconto | moeda }}
      </template>
      <template v-slot:item.forma_pag="{ item }">
        {{ metodoPagamentoExibicao(item.forma_pag) }}
      </template>
      <template v-slot:item.valor_total="{ item }">
        {{ item.valor_total | moeda }}
      </template>
      <template v-slot:item.comissao_eleven="{ item }">
        {{ item.comissao_eleven | moeda }}
      </template>
      <template v-slot:item.comissao_parcela_eleven="{ item }">
        {{ item.comissao_parcela_eleven | moeda }}
      </template>
      <template v-slot:item.total_repasse_eleven="{ item }">
        {{ item.total_repasse_eleven | moeda }}
      </template>
      <template v-slot:item.comissao_pdv="{ item }">
        {{ item.comissao_pdv | moeda }}
      </template>
      <template v-slot:item.comissao_parcela_pdv="{ item }">
        {{ item.comissao_parcela_pdv | moeda }}
      </template>
      <template v-slot:item.total_repasse_pdv="{ item }">
        {{ item.total_repasse_pdv | moeda }}
      </template>
      <template v-slot:item.taxa_processamento="{ item }">
        {{ item.taxa_processamento | moeda }}
      </template>
      <template v-slot:item.taxa_conveniencia="{ item }">
        {{ item.taxa_conveniencia | moeda }}
      </template>
      <template v-slot:item.taxa_pacote="{ item }">
        {{ item.taxa_pacote | moeda }}
      </template>
      <template v-slot:item.taxa_cortesia="{ item }">
        {{ item.taxa_cortesia | moeda }}
      </template>
      <template v-slot:item.taxa_gratuidade="{ item }">
        {{ item.taxa_gratuidade | moeda }}
      </template>
    </v-data-table>

    <v-data-table
      class="rounded-lg"
      hide-default-footer
      :footer-props="{
        class: 'rounded-b-lg',
      }"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      no-data-text="Não há registros."
      loading-text="Buscando informações..."
      :loading="financialReportLoading"
      :headers="headersTotais"
      :items="allFinancialReport.totals"
    >
      <template v-slot:header.valor_total_dinheiro="{ header }">
        {{ header.text }}
        <v-tooltip top max-width="200">
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small dark v-bind="attrs" v-on="on" icon>
              <v-icon> mdi-help-circle-outline </v-icon>
            </v-btn>
          </template>
          <p class="text-justify">
            Valor já contemplado no Total Pagamento, listado à parte apenas a
            título informativo.
          </p>
        </v-tooltip>
      </template>
      <template v-slot:item.valor_total_pedido="{ item }">
        {{ item.valor_total_pedido | moeda }}
      </template>
      <template v-slot:item.valor_total_dinheiro="{ item }">
        {{ item.valor_total_dinheiro | moeda }}
      </template>
      <template v-slot:item.valor_cancelado="{ item }">
        {{ item.valor_cancelado | moeda }}
      </template>
      <template v-slot:item.valor_desconto="{ item }">
        {{ item.valor_desconto | moeda }}
      </template>
      <template v-slot:item.valor_total_juros="{ item }">
        {{ item.valor_total_juros | moeda }}
      </template>
      <template v-slot:item.valor_total_pagamento="{ item }">
        {{ item.valor_total_pagamento | moeda }}
      </template>
      <template v-slot:item.valor_total_comissao_eleven="{ item }">
        {{ item.valor_total_comissao_eleven | moeda }}
      </template>
      <template v-slot:item.valor_total_parc_liberado_eleven="{ item }">
        {{ item.valor_total_parc_liberado_eleven | moeda }}
      </template>
      <template v-slot:item.valor_total_parc_liberado="{ item }">
        {{ item.valor_total_parc_liberado | moeda }}
      </template>
      <template v-slot:item.valor_total_repasse_eleven="{ item }">
        {{ item.valor_total_repasse_eleven | moeda }}
      </template>
      <template v-slot:item.valor_total_taxa_processamento="{ item }">
        {{ item.valor_total_taxa_processamento | moeda }}
      </template>
      <template v-slot:item.valor_total_taxa_conveniencia="{ item }">
        {{ item.valor_total_taxa_conveniencia | moeda }}
      </template>
      <template v-slot:item.valor_total_taxa_pacote="{ item }">
        {{ item.valor_total_taxa_pacote | moeda }}
      </template>
      <template v-slot:item.valor_total_taxa_cortesia="{ item }">
        {{ item.valor_total_taxa_cortesia | moeda }}
      </template>
      <template v-slot:item.valor_total_taxa_gratuidade="{ item }">
        {{ item.valor_total_taxa_gratuidade | moeda }}
      </template>
    </v-data-table>
  </fragment>
</template>
<script>
import dayjs from "dayjs";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "FinancialAnalytical",
  metaInfo: {
    title: "Relatório Analítico Financeiro | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Relatório Analítico Financeiro | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    BaseSelect,
    BaseTextField,
    BaseButton,
  },
  data() {
    return {
      filter: {
        regional: null,
        product: null,
        channel: null,
        payment: null,

        initDateOrders: "",
        initDateViewOrders: "",
        endDateOrders: "",
        endDateViewOrders: "",

        initDateRelease: "",
        initDateViewRelease: "",
        endDateRelease: "",
        endDateViewRelease: "",
      },
      dayjs: dayjs,
      headersPOSLoja: [
        {
          text: "Pedido",
          align: "center",
          sortable: false,
          value: "pedido",
          width: 160,
        },
        {
          text: "Número de Transação POS",
          align: "center",
          sortable: true,
          value: "transactioncode",
          width: 200,
        },
        {
          text: "Forma de Pagamento",
          align: "center",
          sortable: false,
          value: "forma_pag",
          width: 160,
        },
        {
          text: "Parcelas",
          align: "center",
          value: "parcelas",
          width: 150,
        },
        {
          text: "Data/Hora Pedido",
          align: "center",
          value: "dt_pedido",
          width: 150,
        },
        {
          text: "Data/Hora Liberação",
          align: "center",
          value: "dt_liberacao",
          width: 160,
        },
        {
          text: "Parcela Liberada",
          align: "center",
          value: "parcelas_lib",
          width: 150,
        },
        {
          text: "Valor Cancelado",
          align: "center",
          value: "valor_cancelado",
          width: 150,
        },
        {
          text: "Descontos",
          align: "center",
          value: "valor_desconto",
          width: 150,
        },
        {
          text: "Juros",
          align: "center",
          value: "valor_juros",
          width: 150,
        },
        {
          text: "Total Pagamento",
          align: "center",
          value: "valor_total",
          width: 150,
        },
        {
          text: "Taxa de Processamento",
          align: "center",
          value: "taxa_processamento",
          width: 180,
        },
        {
          text: "Taxa de Conveniência",
          align: "center",
          value: "taxa_conveniencia",
          width: 160,
        },
        {
          text: "Taxa Pacote",
          align: "center",
          value: "taxa_pacote",
          width: 130,
        },
        {
          text: "Taxa Cortesia",
          align: "center",
          value: "taxa_cortesia",
          width: 150,
        },
        {
          text: "Taxa Gratuídade",
          align: "center",
          value: "taxa_gratuidade",
          width: 150,
        },
        {
          text: "Comissão Eleven",
          align: "center",
          value: "comissao_eleven",
          width: 150,
        },
        {
          text: "Comissão Parcela Eleven",
          align: "center",
          value: "comissao_parcela_eleven",
          width: 190,
        },
        {
          text: "Total Repasse",
          align: "center",
          value: "total_repasse_eleven",
          width: 150,
        },
      ],
      headersLojas: [
        {
          text: "Pedido",
          align: "center",
          sortable: false,
          value: "pedido",
          width: 160,
        },
        {
          text: "Número de Transação WEB",
          align: "center",
          sortable: true,
          value: "idtransacao",
          width: 220,
        },
        {
          text: "Número de Transação POS",
          align: "center",
          sortable: true,
          value: "transactioncode",
          width: 220,
        },
        {
          text: "Forma de Pagamento",
          align: "center",
          sortable: false,
          value: "forma_pag",
          width: 160,
        },
        {
          text: "Parcelas",
          align: "center",
          value: "parcelas",
          width: 150,
        },
        {
          text: "Data/Hora Pedido",
          align: "center",
          value: "dt_pedido",
          width: 150,
        },
        {
          text: "Data/Hora Liberação",
          align: "center",
          value: "dt_liberacao",
          width: 160,
        },
        {
          text: "Parcela Liberada",
          align: "center",
          value: "parcelas_lib",
          width: 150,
        },
        {
          text: "Total Pagamento",
          align: "center",
          value: "valor_total",
          width: 150,
        },
        {
          text: "Valor Cancelado",
          align: "center",
          value: "valor_cancelado",
          width: 150,
        },
        {
          text: "Descontos",
          align: "center",
          value: "valor_desconto",
          width: 150,
        },
        {
          text: "Juros",
          align: "center",
          value: "valor_juros",
          width: 150,
        },
        {
          text: "Taxa de Conveniência",
          align: "center",
          value: "taxa_conveniencia",
          width: 170,
        },
        {
          text: "Taxa de Processamento",
          align: "center",
          value: "taxa_processamento",
          width: 180,
        },
        {
          text: "Taxa Pacote",
          align: "center",
          value: "taxa_pacote",
          width: 150,
        },
        {
          text: "Taxa Cortesia",
          align: "center",
          value: "taxa_cortesia",
          width: 150,
        },
        {
          text: "Taxa Gratuídade",
          align: "center",
          value: "taxa_gratuidade",
          width: 150,
        },
        {
          text: "Comissão Parcela Eleven",
          align: "center",
          value: "comissao_parcela_eleven",
          width: 190,
        },
        {
          text: "Total Repasse",
          align: "center",
          value: "total_repasse_eleven",
          width: 150,
        },
      ],
      headersWEBLojas: [
        {
          text: "Pedido",
          align: "center",
          sortable: false,
          value: "pedido",
          width: 150,
        },
        {
          text: "Número de Transação WEB",
          align: "center",
          sortable: true,
          value: "idtransacao",
          width: 200,
        },
        {
          text: "Forma de Pagamento",
          align: "center",
          sortable: false,
          value: "forma_pag",
          width: 160,
        },
        {
          text: "Parcelas",
          align: "center",
          value: "parcelas",
          width: 150,
        },
        {
          text: "Data/Hora Pedido",
          align: "center",
          value: "dt_pedido",
          width: 150,
        },
        {
          text: "Data/Hora Liberação",
          align: "center",
          value: "dt_liberacao",
          width: 160,
        },
        {
          text: "Parcela Liberada",
          align: "center",
          value: "parcelas_lib",
          width: 150,
        },
        {
          text: "Total Pagamento",
          align: "center",
          value: "valor_total",
          width: 180,
        },
        {
          text: "Valor Cancelado",
          align: "center",
          value: "valor_cancelado",
          width: 150,
        },
        {
          text: "Descontos",
          align: "center",
          value: "valor_desconto",
          width: 150,
        },
        {
          text: "Juros",
          align: "center",
          value: "valor_juros",
          width: 150,
        },
        {
          text: "Taxa de Processamento",
          align: "center",
          value: "taxa_processamento",
          width: 180,
        },
        {
          text: "Taxa de Conveniência",
          align: "center",
          value: "taxa_conveniencia",
          width: 170,
        },
        {
          text: "Taxa Pacote",
          align: "center",
          value: "taxa_pacote",
          width: 150,
        },
        {
          text: "Taxa Cortesia",
          align: "center",
          value: "taxa_cortesia",
          width: 150,
        },
        {
          text: "Taxa Gratuídade",
          align: "center",
          value: "taxa_gratuidade",
          width: 150,
        },
        {
          text: "Comissão Eleven",
          align: "center",
          value: "comissao_eleven",
          width: 150,
        },
        {
          text: "Comissão Parcela Eleven",
          align: "center",
          value: "comissao_parcela_eleven",
          width: 190,
        },
        {
          text: "Total Repasse",
          align: "center",
          value: "total_repasse_eleven",
          width: 150,
        },
      ],
      headersTotais: [
        {
          text: "Total Pagamento",
          align: "center",
          value: "valor_total_pagamento",
          width: 180,
        },
        {
          text: "Total Pagamento Dinheiro",
          align: "center",
          value: "valor_total_dinheiro",
          width: 210,
        },
        {
          text: "Total Cancelado",
          align: "center",
          value: "valor_cancelado",
          width: 200,
        },
        {
          text: "Total Descontos",
          align: "center",
          value: "valor_desconto",
          width: 200,
        },
        {
          text: "Juros",
          align: "center",
          value: "valor_total_juros",
          width: 180,
        },
        {
          text: "Total Taxa de Conveniência",
          align: "center",
          value: "valor_total_taxa_conveniencia",
          width: 250,
        },
        {
          text: "Total Taxa de Processamento",
          align: "center",
          value: "valor_total_taxa_processamento",
          width: 250,
        },
        {
          text: "Total Taxa Pacote",
          align: "center",
          value: "valor_total_taxa_pacote",
          width: 250,
        },
        {
          text: "Total Taxa Cortesia",
          align: "center",
          value: "valor_total_taxa_cortesia",
          width: 250,
        },
        {
          text: "Total Taxa Gratuidade",
          align: "center",
          value: "valor_total_taxa_gratuidade",
          width: 250,
        },
        {
          text: "Total Comissão Parcela",
          align: "center",
          value: "valor_total_parc_liberado_eleven",
          width: 180,
        },
        {
          text: "Total Repasse",
          align: "center",
          value: "valor_total_repasse_eleven",
          width: 180,
        },
      ],
      activePickerOrders: null,
      activePickerOrders2: null,
      activePickerRelease: null,
      activePickerRelease2: null,
      date: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      disableRegionais: false,
      tipo_pessoa: [],
    };
  },
  watch: {
    "$store.getters.storeSequencial": function () {
      this.fetchEvents({ producerId: this.storeSequencial });
      this.filterFinancialReport();
    },
    menu(val) {
      val && setTimeout(() => (this.activePickerOrders = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePickerOrders2 = "MONTH"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePickerRelease = "MONTH"));
    },
    menu4(val) {
      val && setTimeout(() => (this.activePickerRelease2 = "MONTH"));
    },
  },
  methods: {
    ...mapActions([
      "fetchFinancialReport",
      "fetchChannelSalesOptions",
      "fetchRegionais",
      "fetchPaymentMethodOptions",
      "fetchEvents",
    ]),
    ...mapMutations(["setFinancialReportLoading", "setReportsFilter"]),

    filterFinancialReport() {
      this.setFinancialReportLoading(true);
      let filter = {
        producerId: this.storeSequencial,
        tipo_pessoa: "LOJA",
        idregional: this.filter.regional,
        canal_venda: this.filter.channel,
        forma_de_pagamento: this.filter.payment,
      };

      if (this.filter.initDateViewOrders) {
        Object.assign(filter, {
          dthr_ini: `${this.filter.initDateOrders} 00:00`,
        });
      }

      if (this.filter.endDateViewOrders) {
        Object.assign(filter, {
          dthr_fim: `${this.filter.endDateOrders} 23:59`,
        });
      }

      if (this.filter.initDateViewRelease) {
        Object.assign(filter, {
          dthr_ini_lib: `${this.filter.initDateRelease} 00:00`,
        });
      }

      if (this.filter.endDateViewRelease) {
        Object.assign(filter, {
          dthr_fim_lib: `${this.filter.endDateRelease} 23:59`,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
      });

      this.fetchFinancialReport(filter);
      this.setReportsFilter(filter);
    },

    metodoPagamentoExibicao(item) {
      if (item === null) {
        return "-";
      } else if (item === "QRCODE") {
        return "PIX";
      } else {
        return item;
      }
    },

    searchProduto(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );
      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    searchTipoPessoa(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.text.toString().toLocaleLowerCase().normalize("NFD")
      );
      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
      this.filter.initDateViewOrders = dayjs(date).format("DD/MM/YYYY");
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.filter.endDateViewOrders = dayjs(date).format("DD/MM/YYYY");
    },
    save3(date) {
      this.$refs.menu.save(date);
      this.filter.initDateViewRelease = dayjs(date).format("DD/MM/YYYY");
    },
    save4(date) {
      this.$refs.menu2.save(date);
      this.filter.endDateViewRelease = dayjs(date).format("DD/MM/YYYY");
    },
  },

  computed: {
    ...mapGetters([
      "storeSequencial",
      "intervalDates",
      "allFinancialReport",
      "financialReportLoading",
      "isAdmin",
      "channelSales",
      "regionais",
      "paymentMethods",
      "allEvents",
    ]),
    headerTableValues() {
      switch (this.filter.channel) {
        case "PDV_POS":
          return this.headersPOSLoja;
        case "PDV_QRCODE":
        case "ECOMMERCE":
        case "MARKETPLACE":
          return this.headersWEBLojas;
        default:
          return this.headersLojas;
      }
    },
  },
  mounted() {
    this.filterFinancialReport();
    this.fetchPaymentMethodOptions();
    this.fetchChannelSalesOptions();
    this.fetchRegionais();
    if (this.storeSequencial) {
      this.fetchEvents({ producerId: this.storeSequencial });
    }
  },
  destroyed() {
    this.filter = {
      regional: null,
      product: null,
      channel: null,
      payment: null,
    };
  },
};
</script>
<style scoped></style>
